import _ from 'lodash';
import { ACTION_DEMO_START } from '../actions/demo';

const DEFAULT_UPDATES_INTERVAL = 30000;

export default function (state, action) {
    if (!state) {
        return {
            connectionWasChecked: false,
            hasAPIConnection: false,
            hasUser: false,
            user: null,
            authToken: null,
            prefill: null,
            updatesInterval: DEFAULT_UPDATES_INTERVAL,
            lastUpdate: null,
        };
    }

    switch (action.type) {
        case 'SESSION_LOGIN':
            state = Object.assign({}, state, {
                hasUser: true,
                user: action.user,
                authToken: action.user.public_key,
            });
            break;
        case 'SESSION_LOGOUT':
            state = Object.assign({}, state, {
                hasUser: false,
                user: null,
                authToken: null,
            });
            break;
        case 'USER_DATA_RECEIVED':
            if (state.user.id == action.user.id) {
                state = Object.assign({}, state, { user: Object.assign({}, state.user, action.user) });

                if (action.user.public_key) {
                    // Refresh token, e.g. after password update
                    state = Object.assign({}, state, { authToken: action.user.public_key });
                }
            }

            break;
        case 'SESSION_UPDATES':
            state = {
                ...state,
                connectionWasChecked: true,
                hasAPIConnection: true,
                updatesInterval: action.updatesInterval || DEFAULT_UPDATES_INTERVAL,
                lastUpdate: action.updates,
            };
            break;
        case 'SESSION_SET_API_CONNECTION_STATUS':
            state = {
                ...state,
                connectionWasChecked: true,
                hasAPIConnection: action.connected,
            };
            break;
        case 'SESSION_PREFILL':
            state = {
                ...state,
                prefill: action.summary,
            };
            break;
        case 'SESSION_CLEAR_PREFILL':
            state = {
                ...state,
                prefill: null,
            };
            break;
        case 'UPDATES_TRIGGERED':
            state = { ...state, lastReceivedUpdate: new Date().toISOString() };
            breal;
        case ACTION_DEMO_START:
            state = {
                ...state,
                user: {
                    id: action.userId,
                    first_name: 'Demo',
                    last_name: 'Account',
                },
                hasUser: true,
            };
            break;
    }

    return state;
}
